@if (
  {
    registrationFormValues: registrationFormValues$ | async,
    isLoggingIn: isLoggingIn$ | async,
    isRegisteringUser: isRegisteringUser$ | async,
    registrationOtp: registrationOtp$ | async,
    isUserKnown: isUserKnown$ | async,
    violations: violations$ | async
  };
  as STATE
) {
  <main class="email-confirmation-form">
    <hgroup>
      <h2>
        {{
          STATE.isUserKnown
            ? 'Compte déjà associé à une ou plusieurs entreprises'
            : 'Confirmation par e-mail'
        }}
      </h2>
      <p>
        {{
          STATE.isUserKnown
            ? 'Vos données correspondent à un compte utilisateur existant. Veuillez vous connecter pour poursuivre la création de votre nouvelle entreprise.'
            : ' Vérifiez votre boîte mail pour activer votre compte en toute sécurité.'
        }}
      </p>
    </hgroup>

    <form
      class="form"
      [ngxsForm]="statePropertyPath"
      [formGroup]="emailConfirmationForm"
    >
      @if (!STATE.isUserKnown) {
        <div class="form__row">
          <div class="form__group">
            <label for="lastName" class="form__label"
              >Nom
              <span class="form__label--required">*</span>
            </label>
            <div class="form__item form__item--with-prefix">
              <span class="form__prefix">
                <mat-icon svgIcon="dgi-profile" color="primary"></mat-icon>
              </span>
              <input
                type="text"
                id="lastName"
                formControlName="lastName"
                class="form__input"
                placeholder="Ex. Doe"
              />
            </div>

            @if (lastName?.touched && lastName?.errors?.required) {
              <mat-error
                [innerHtml]="'Ce champ est requis'"
                class="form__error-red"
              >
              </mat-error>
            }
            @if (lastName?.getError('customError'); as customError) {
              <mat-error [innerHtml]="customError" class="form__error-red">
              </mat-error>
            }
          </div>

          <div class="form__group">
            <label for="firstName" class="form__label"
              >Prénoms
              <span class="form__label--required">*</span>
            </label>
            <div class="form__item form__item--with-prefix">
              <span class="form__prefix">
                <mat-icon svgIcon="dgi-profile" color="primary"></mat-icon>
              </span>
              <input
                type="text"
                id="firstName"
                formControlName="firstName"
                class="form__input"
                placeholder="Ex. John"
              />
            </div>

            @if (firstName?.touched && firstName?.errors?.required) {
              <mat-error
                [innerHtml]="'Ce champ est requis'"
                class="form__error-red"
              >
              </mat-error>
            }
            @if (firstName?.getError('customError'); as customError) {
              <mat-error [innerHtml]="customError" class="form__error-red">
              </mat-error>
            }
          </div>
        </div>

        <div class="form__group">
          <label for="email" class="form__label">Adresse électronique</label>
          <div class="form__item form__item--with-prefix form__item--readonly">
            <span class="form__prefix">
              <mat-icon svgIcon="dgi-msg" color="primary"></mat-icon>
            </span>
            <input
              type="email"
              readonly
              disabled
              id="email"
              [value]="STATE.registrationFormValues?.model?.email"
              class="form__input"
              placeholder="Saisir l'adresse électronique"
            />
          </div>
        </div>
        <div class="form__group">
          <phone-field
            uniqueId="phoneNumber"
            label="Téléphone"
            formControlName="phoneNumber"
            [preferredCountries]="['CI']"
          >
            @if (phoneNumber?.touched && phoneNumber?.errors?.required) {
              <mat-error
                [innerHtml]="'Ce champ est requis'"
                class="form__error-red"
              >
              </mat-error>
            }
            @if (phoneNumber?.getError('customError'); as customError) {
              <mat-error [innerHtml]="customError" class="form__error-red">
              </mat-error>
            }

            @if (phoneNumber?.getError('httpError'); as httpError) {
              <mat-error class="form__error-red">
                {{ httpError }}
              </mat-error>
            }
          </phone-field>
        </div>
        <div class="form__group">
          <label for="otpCode" class="form__label"
            >Code OTP
            <span class="form__label--required">*</span>
          </label>
          <div class="form__item form__item--with-prefix">
            <span class="form__prefix">
              <mat-icon svgIcon="dgi-list" color="primary"></mat-icon>
            </span>
            <input
              type="text"
              id="otpCode"
              formControlName="otpCode"
              [value]=""
              class="form__input"
              placeholder="Saisir le code à 6 chiffres"
              maxlength="6"
              pattern="[0-9]{6}"
              inputmode="numeric"
              (keydown)="onOtpKeydown($event)"
            />
          </div>
          @if (otpCode?.touched && otpCode?.errors?.required) {
            <mat-error
              [innerHtml]="'Ce champ est requis'"
              class="form__error-red"
            >
            </mat-error>
          }

          @if (otpCode?.touched && otpCode?.errors?.pattern) {
            <mat-error
              [innerHtml]="'Le code OTP doit exactement contenir 6 chiffres'"
              class="form__error-red"
            >
            </mat-error>
          }
          <mat-error
            *ngIf="otpCode?.getError('httpError') as httpError"
            class="form__error-red"
          >
            {{ httpError }}
          </mat-error>
        </div>

        <div class="form__countdown">
          <auth-countdown
            [expiresAt]="STATE.registrationOtp?.expiresAt"
            (resendOtp)="onResendOtp()"
          ></auth-countdown>
        </div>

        <hr />

        @if ({ value: false }; as togglePassword) {
          <div class="form__group">
            <label for="password" class="form__label">
              <p class="form__label--position">
                <span class="form__label--color"
                  >Nouveau mot de passe
                  <span class="form__label--required">*</span>
                </span>
              </p>
            </label>

            <div class="form__item form__item--with-prefix">
              <span class="form__prefix">
                <mat-icon svgIcon="dgi-password" color="primary"></mat-icon>
              </span>
              <input
                type="password"
                id="password"
                formControlName="password"
                class="form__input"
                placeholder="Créer un mot de passe"
                #passwordInput
              />
              <button
                type="button"
                mat-icon-button
                (click)="
                  togglePassword.value = !togglePassword.value;
                  passwordInput.type = togglePassword.value
                    ? 'text'
                    : 'password'
                "
                tabindex="-1"
                class="form__suffix"
                aria-label="Afficher ou masquer le mot de passe"
              >
                <mat-icon
                  svgIcon="{{
                    togglePassword.value ? 'dgi-view' : 'dgi-view_off'
                  }}"
                ></mat-icon>
              </button>
            </div>

            <div class="form__error-container">
              @if (password?.touched && password?.errors?.required) {
                <mat-error
                  [innerHtml]="'Ce champ est requis'"
                  class="form__error-red"
                >
                </mat-error>
              }
              @if (password?.touched && password?.errors?.minlength) {
                <mat-error
                  [innerHtml]="'Minimum 8 caractères'"
                  class="form__error-red"
                >
                </mat-error>
              }
              @if (password?.touched && password?.errors?.uppercase) {
                <mat-error
                  [innerHtml]="
                    'Le mot de passe doit contenir au moins une majuscule'
                  "
                  class="form__error-red"
                ></mat-error>
              }
              @if (password?.touched && password?.errors?.lowercase) {
                <mat-error
                  [innerHtml]="
                    'Le mot de passe doit contenir au moins une minuscule'
                  "
                  class="form__error-red"
                ></mat-error>
              }
              @if (password?.touched && password?.errors?.digit) {
                <mat-error
                  [innerHtml]="
                    'Le mot de passe doit contenir au moins un chiffre'
                  "
                  class="form__error-red"
                ></mat-error>
              }
              @if (password?.touched && password?.errors?.specialChar) {
                <mat-error
                  [innerHtml]="
                    'Le mot de passe doit contenir au moins un caractère spécial'
                  "
                  class="form__error-red"
                ></mat-error>
              }

              <mat-error
                *ngIf="password?.getError('httpError') as httpError"
                class="form__error-red"
              >
                {{ httpError }}
              </mat-error>
            </div>
          </div>
        }

        @if ({ value: false }; as togglePassword) {
          <div class="form__group">
            <label for="confirmPassword" class="form__label">
              <p class="form__label--position">
                <span class="form__label--color"
                  >Confirmation du mot de passe
                  <span class="form__label--required">*</span>
                </span>
              </p>
            </label>
            <div class="form__item form__item--with-prefix">
              <span class="form__prefix">
                <mat-icon svgIcon="dgi-password" color="primary"></mat-icon>
              </span>
              <input
                type="password"
                #confirmPasswordInput
                id="confirmPassword"
                formControlName="confirmPassword"
                class="form__input"
                placeholder="Confirmez votre mot de passe"
              />
              <button
                type="button"
                mat-icon-button
                (click)="
                  togglePassword.value = !togglePassword.value;
                  confirmPasswordInput.type = togglePassword.value
                    ? 'text'
                    : 'password'
                "
                tabindex="-1"
                class="form__suffix"
                aria-label="Afficher ou masquer le mot de passe"
              >
                <mat-icon
                  svgIcon="{{
                    togglePassword.value ? 'dgi-view' : 'dgi-view_off'
                  }}"
                ></mat-icon>
              </button>
            </div>

            @if (
              confirmPassword?.touched && confirmPassword?.errors?.required
            ) {
              <mat-error
                [innerHtml]="'Ce champ est requis'"
                class="form__error-red"
              >
              </mat-error>
            }

            @if (
              confirmPassword?.touched &&
              confirmPassword?.errors?.['passwordsMismatch']
            ) {
              <mat-error
                [innerHtml]="'Les mots de passe ne correspondent pas'"
                class="form__error-red"
              >
              </mat-error>
            }
            @if (
              confirmPassword?.touched && confirmPassword?.errors?.minlength
            ) {
              <mat-error
                [innerHtml]="'Minimum 8 caractères'"
                class="form__error-red"
              >
              </mat-error>
            }
            <mat-error
              *ngIf="confirmPassword?.getError('httpError') as httpError"
              class="form__error-red"
            >
              {{ httpError }}
            </mat-error>
          </div>
        }
      } @else {
        <div class="form__group">
          <label for="email" class="form__label">Adresse électronique</label>
          <div class="form__item form__item--with-prefix form__item--readonly">
            <span class="form__prefix">
              <mat-icon svgIcon="dgi-msg" color="primary"></mat-icon>
            </span>
            <input
              type="email"
              readonly
              disabled
              id="email"
              [value]="STATE.registrationFormValues?.model?.email"
              class="form__input"
              placeholder="Saisir l'adresse électronique"
            />
          </div>
        </div>
        @if ({ value: false }; as togglePassword) {
          <div class="form__group">
            <label for="password" class="form__label">
              <p class="form__label--position">
                <span class="form__label--color">Mot de passe</span>
              </p>
            </label>
            <div class="form__item form__item--with-prefix">
              <span class="form__prefix">
                <mat-icon svgIcon="dgi-password" color="primary"></mat-icon>
              </span>
              <input
                #passwordInput
                type="password"
                id="password"
                formControlName="password"
                class="form__input"
                placeholder="Saisir le mot de passe"
              />
              <button
                type="button"
                mat-icon-button
                (click)="
                  togglePassword.value = !togglePassword.value;
                  passwordInput.type = togglePassword.value
                    ? 'text'
                    : 'password'
                "
                tabindex="-1"
                class="form__suffix"
                aria-label="Afficher ou masquer le mot de passe"
              >
                <mat-icon
                  svgIcon="{{
                    togglePassword.value ? 'dgi-view' : 'dgi-view_off'
                  }}"
                ></mat-icon>
              </button>
            </div>
            @if (password?.touched && password?.errors?.required) {
              <mat-error
                [innerHtml]="'Ce champ est requis'"
                class="form__error-red"
              >
              </mat-error>
            }
            @if (password?.touched && password?.errors?.minlength) {
              <mat-error
                [innerHtml]="'Minimum 8 caractères'"
                class="form__error-red"
              >
              </mat-error>
            }
            <mat-error
              *ngIf="password?.getError('httpError') as httpError"
              class="form__error-red"
            >
              {{ httpError }}
            </mat-error>
          </div>
        }
      }

      <div class="form__actions">
        <button
          button
          (click)="registerUser()"
          [loading]="!!(STATE.isRegisteringUser || STATE.isLoggingIn)"
          [disabled]="STATE.isRegisteringUser || emailConfirmationForm.invalid"
          loadingText="Activation en cours..."
          [fullWidth]="true"
        >
          Continuer
        </button>
      </div>
    </form>
  </main>
}
